import { Box, Skeleton, useTheme } from "@mui/material";

const EvidenceLoadingSkeleton = () => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        height : "100%",
        width: "100%",
        backgroundColor: "#FFFFFF",
        borderRadius: "12px",
        border: `1px solid ${theme.customColors?.border?.main}`,
        boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          px: 3,
          py: 2,
          borderBottom: `1px solid ${theme.customColors?.border?.main}`,
          backgroundColor: "#FAFBFC",
        }}
      >
        <Skeleton variant="text" width="180px" height={28} />
        <Skeleton variant="circular" width={36} height={36} />
      </Box>
      <Box sx={{ p: 3, flex: 1, display: "flex" }}>
        <Skeleton variant="rectangular" width="100%" sx={{ height: "100%", borderRadius: "8px" }} />
      </Box>
    </Box>
  );
};

export default EvidenceLoadingSkeleton;
